import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  activeContainer: "pitchType",
  taggingFlowStep: 0,
};

const hotkeySlice = createSlice({
  name: "hotkeyContainer",
  initialState,
  reducers: {
    incrementTaggingFlowStep: (state) => {
      state.taggingFlowStep++;
    },
    decrementTaggingFlowStep: (state) => {
      state.taggingFlowStep--;
    },
    resetTaggingFlowStep: (state) => {
      state.taggingFlowStep = 0;
    },
    setTaggingFlowStep: (state, action) => {
      state.taggingFlowStep = action.payload;
    },
  },
});

export const {
  incrementTaggingFlowStep,
  decrementTaggingFlowStep,
  resetTaggingFlowStep,
  setTaggingFlowStep,
} = hotkeySlice.actions;
export default hotkeySlice.reducer;
